import { render } from "./TabsEnumFilter.vue?vue&type=template&id=2f1e84c9&scoped=true&ts=true"
import script from "./TabsEnumFilter.ts?vue&type=script&lang=ts"
export * from "./TabsEnumFilter.ts?vue&type=script&lang=ts"

import "./TabsEnumFilter.scss?vue&type=style&index=0&id=2f1e84c9&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1e84c9"]])

export default __exports__